module.exports = __webpack_public_path__ + "static/pokoj-nr5-photo04-nikon_thumb-dc417e564f162aea1def5f06423fbc05.jpg";